<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmonthchange_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/v4ward/car/carmonthchange';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '主键',
            prop: 'id',
            rules: [
              {
                required: true,
                message: '请输入主键',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车场id',
            prop: 'spaceId',
            rules: [
              {
                required: true,
                message: '请输入停车场id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车场名称',
            prop: 'spaceName',
            rules: [
              {
                required: true,
                message: '请输入停车场名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '小区id',
            prop: 'areaId',
            rules: [
              {
                required: true,
                message: '请输入小区id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '客户id',
            prop: 'customerId',
            rules: [
              {
                required: true,
                message: '请输入客户id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '客户姓名',
            prop: 'customerName',
            rules: [
              {
                required: true,
                message: '请输入客户姓名',
                trigger: 'change',
              },
            ],
          },
          {
            label: '客户手机号',
            prop: 'customerPhone',
            rules: [
              {
                required: true,
                message: '请输入客户手机号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号',
            prop: 'carNo',
            rules: [
              {
                required: true,
                message: '请输入车牌号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '租赁起期',
            prop: 'buyStartTime',
            rules: [
              {
                required: true,
                message: '请输入租赁起期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '租赁止期',
            prop: 'buyEndTime',
            rules: [
              {
                required: true,
                message: '请输入租赁止期',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆分类',
            prop: 'carClass',
            rules: [
              {
                required: true,
                message: '请输入车辆分类',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车辆类型(1,月租车,2免费车,3夜间车,4白天车)',
            prop: 'carType',
            rules: [
              {
                required: true,
                message: '请输入车辆类型(1,月租车,2免费车,3夜间车,4白天车)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '异动类型(1,新增,2修改,3删除)',
            prop: 'changeType',
            rules: [
              {
                required: true,
                message: '请输入异动类型(1,新增,2修改,3删除)',
                trigger: 'change',
              },
            ],
          },
          {
            label: '停车车位编号',
            prop: 'lotNo',
            rules: [
              {
                required: true,
                message: '请输入停车车位编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '月卡车id',
            prop: 'carMonthId',
            rules: [
              {
                required: true,
                message: '请输入月卡车id',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注1',
            prop: 'remark1',
            rules: [
              {
                required: true,
                message: '请输入备注1',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注2',
            prop: 'remark2',
            rules: [
              {
                required: true,
                message: '请输入备注2',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注3',
            prop: 'remark3',
            rules: [
              {
                required: true,
                message: '请输入备注3',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthchange_add, false),
        viewBtn: this.vaildData(this.permission.carmonthchange_view, false),
        delBtn: this.vaildData(this.permission.carmonthchange_delete, false),
        editBtn: this.vaildData(this.permission.carmonthchange_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
